var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"fill_need",class:{'filled':_vm.cell_data.filled}},[_vm._v("\n    "+_vm._s(_vm.cell_data.fill_level)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }